export const translations = {
  en: {
    home: "Home",
    about: "About",
    approach: "Approach",
    services: "Services",
    download: "Download",
    blog: "Blog",
    report: "Report",
  },

  vi: {
    home: "Trang chủ",
    about: "Giới thiệu",
    approach: "Phương pháp",
    services: "Dịch vụ",
    download: "Tải xuống",
    blog: "Bài viết",
    report: "Báo cáo",
  },
};
